/**
 * Standardized logger that funnels all console usage through one place.
 * This allows eslint rules to forbid console.* anywhere else in the codebase.
 */
const logger = {
  error: (...args) => console.error(...args),
  warn: (...args) => console.warn(...args),
  info: (...args) => console.info(...args),
  debug: (...args) => console.debug(...args),
};

export default logger;
